/**
 * Studio visit: Mumbai detection for the PDP invitation.
 *
 * Detection is deliberately generous — a Mumbai client who is not shown the
 * invitation is a lost high-intent lead, while a Pune visitor seeing it costs
 * nothing. So: Mumbai and the wider MMR count, ?city=mumbai forces it on (for
 * Mumbai-targeted ad campaigns, where Meta already did the geo work), and
 * ?city=other forces it off for QA. The city lookup runs once per session and
 * is cached in sessionStorage.
 *
 * The entry point stays hidden until a positive match, never the reverse, so
 * non-Mumbai visitors can never see a flash of studio content. The booking
 * form itself lives on the internal app; this only reveals the link to it.
 */
(function () {
  'use strict';

  var CACHE_KEY = 'duavaa_geo_city';
  var GEO_ENDPOINT = 'https://get.geojs.io/v1/ip/geo.json';
  var MUMBAI_CITIES = [
    'mumbai', 'bombay', 'navi mumbai', 'thane', 'mira bhayandar', 'kalyan',
    'dombivli', 'vasai', 'virar', 'bhiwandi', 'ulhasnagar', 'panvel', 'powai'
  ];

  function param(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
      return null;
    }
  }

  function isMumbaiCity(city) {
    if (!city) return false;
    var c = String(city).toLowerCase().trim();
    for (var i = 0; i < MUMBAI_CITIES.length; i++) {
      if (c.indexOf(MUMBAI_CITIES[i]) !== -1) return true;
    }
    return false;
  }

  function cached() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function cache(value) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(value));
    } catch (e) {
      /* private mode: just skip caching */
    }
  }

  /** Resolves { city, isMumbai }; never rejects. */
  function resolveCity() {
    var override = (param('city') || '').toLowerCase();
    if (override === 'mumbai') return Promise.resolve({ city: 'Mumbai', isMumbai: true, source: 'url' });
    if (override) return Promise.resolve({ city: override, isMumbai: false, source: 'url' });

    var hit = cached();
    if (hit) return Promise.resolve(hit);

    return fetch(GEO_ENDPOINT, { mode: 'cors', credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        var city = json && json.city ? json.city : '';
        var result = { city: city, isMumbai: isMumbaiCity(city), source: 'geo' };
        cache(result);
        return result;
      })
      .catch(function () {
        return { city: '', isMumbai: false, source: 'error' };
      });
  }


  function init() {
    var entry = document.querySelector('[data-studio-visit]');
    if (!entry) return; // not rendered: international domain, or out of stock

    resolveCity().then(function (geo) {
      window.DuavaaGeo = geo;
      if (!geo.isMumbai) return; // stays hidden
      document.documentElement.classList.add('geo-mumbai');
      entry.hidden = false;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
